export default __webpack_public_path__ + "static/media/client-remark.6ea47e77.svg";